import React from 'react';
import Select from'../../base/SelectWithLabel/SelectWithLabel';

const QuantityCorrectionsProposal = ({label,name,onChange,value,values}) => {

    return (
        <Select
            className="col-xs-12"
            inputClassName="col-xs-12 col-sm-6"
            label={label}
            name={name}
            values={values}
            onChange={onChange}
            value={value} />
    );
}
    

export default QuantityCorrectionsProposal;


// WEBPACK FOOTER //
// ./src/components/ComplaintPositionComponents/QuantityCorrectionsProposal/QuantityCorrectionsProposal.js